import { useEntitiesFromSearch } from 'api/search'
import { useMemo } from 'react'
import { NewDeal, Product } from 'types'
import { buildMasterAgreements, MasterAgreement } from 'utils/agreementVersioning'

export function useMasterAgreements(PK: string | undefined) {
  const { deals, products: allProducts, isItemsLoading } = useEntitiesFromSearch()

  const result = useMemo(() => {
    if (!PK || !deals || !allProducts) {
      return { agreements: [] as MasterAgreement[], standaloneDeals: [] as NewDeal[] }
    }

    const orgDeals = deals.filter((d: NewDeal) => d?.PK === PK)
    const orgProducts = allProducts.filter((p: Product) => p?.PK === PK)

    return buildMasterAgreements(orgDeals, orgProducts)
  }, [PK, deals, allProducts])

  return {
    agreements: result.agreements,
    standaloneDeals: result.standaloneDeals,
    isLoading: isItemsLoading,
  }
}
